import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { api } from "../../api";
import { CardOption } from "../../components/";
import Button from "@mui/material/Button";
import * as Images from "../../themes/images";

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locationArray: [],
      locations: [],
      selectedLocation: "",
      carTypeOptions: [
        {
          name: "Sedan",
          isSelected: false,
        },
        {
          name: "Wagon / SUV",
          isSelected: false,
        },
        {
          name: "4WD / 7 Seater",
          isSelected: false,
        },
        {
          name: "RV / Caravan",
          isSelected: false,
        },
      ],
      selectedTime: "",
      customerEmail: this.props?.bookingUserDetails?.email ? this.props?.bookingUserDetails?.email : "", 
    };
    this.handleSelectedLocation = this.handleSelectedLocation.bind(this);
    this.changeTypeSelected = this.changeTypeSelected.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this); // Bind email change handler
  }

  async getLocations() {
    let res = await api("location/pricing", "GET", null);
    if (res.status === 200) {
      if (res.data.success) {
        let locations = res.data.pricing.map(function (item, index) {
          return { label: item.seoName, id: item._id };
        });
        this.setState({
          locations: locations,
          locationArray: res.data.pricing,
        });
      }
    } else {
      console.log("failed to get pricing: ", res);
    }
  }

  handleSelectedLocation(value) {
    if (value) {
      let locationid = value.id;
      let locations = this.state.locationArray;
      for (let index = 0; index < locations.length; index++) {
        const element = locations[index];
        if (element._id === locationid) {
          this.setState({
            selectedLocation: element,
          });
          this.props.handleSelectedLocation(element);
          break;
        }
      }
    } else {
      this.setState({
        selectedLocation: "",
      });
      this.props.handleSelectedLocation("");
    }
  }

  changeTypeSelected(value) {
    this.props.handleSelectedVehicleType(value);
    this.setState((prevState) => ({
      carTypeOptions: prevState.carTypeOptions.map((obj) =>
        obj.name === value
          ? Object.assign(obj, { isSelected: true })
          : Object.assign(obj, { isSelected: false })
      ),
    }));
  }

  handleEmailChange(event) {
    const email = event.target.value;
    this.setState({ customerEmail: email });
    this.props.handleBookingUserDetails({
      email: email
    });
  }

  componentDidMount() {
    this.getLocations();
    if (this.props.selectedVehicleType !== "") {
      this.setState((prevState) => ({
        carTypeOptions: prevState.carTypeOptions.map((obj) =>
          obj.name === this.props.selectedVehicleType
            ? Object.assign(obj, { isSelected: true })
            : Object.assign(obj, { isSelected: false })
        ),
      }));
    }
  }

  render() {
    let parentThis = this;

    return (
      <div className="detailsStep">
        <div
          className={
            "locationDetailSection "}
        >
          <div className="emailInputSection">
            <h3>Enter your email</h3>
            <div className="inputArea">
              <TextField
                id="customerEmail"
                label="Email"
                variant="outlined"
                fullWidth
                value={this.state.customerEmail}
                onChange={this.handleEmailChange}
              />
            </div>
          </div>
          <h3>Carwash location</h3>
          <div className="inputArea">
            <Autocomplete
              disablePortal
              id="locationsInput"
              options={this.state.locations}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Select a location" />
              )}
              onChange={(event, newValue) => {
                this.handleSelectedLocation(newValue);
              }}
              value={
                this.props.selectedLocationName !== ""
                  ? this.props.selectedLocationName
                  : ""
              }
            />
            <div className="locationViewButton">
              <p>Select</p>
            </div>
          </div>
          <div className="vehicleTypeSection">
            <h3>Choose your vehicle type</h3>
            <div className="carTypeOptions">
              {this.state.carTypeOptions.map(function (item) {
                return (
                  <CardOption
                    item={item}
                    select={(item) => parentThis.changeTypeSelected(item)}
                    key={item.name}
                  />
                );
              })}
            </div>
          </div>
          <div className="bookingTimeSection">
            <h3>Arrival Time</h3>
            <p className="bookingNote1">
              Note: Bookings within the hour aren't accepted
            </p>
            <Button
              className="bookingTimeButton"
              onClick={() =>
                this.props.openDateModal(!this.props.openBookingModal)
              }
            >
              <span>
                {this.props.selectedBookingTime
                  ? this.props.selectedBookingTime
                  : "Select your booking date and time"}
              </span>
              <img
                src={Images.calendarIco}
                className="calendarIco"
                alt="calendar"
              />
            </Button>
            <p className="bookingNote2">
              Please Note: Drive-in available any time during open hours
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Details;